/* eslint-disable */
export default {
  _asapbold: 'asapbold',
  _asapregular: 'asapregular',
  _cardenio_modernregular: 'cardenio_modernregular',
}